import React from "react";
import PandaQuestion1 from "../../assets/images/Panda/PandaQuestion1.png";
import SectionStrong from "../../components/main/SectionStrong";
import SectionQuestion from "../../components/main/SectionQuestion";
import SectionBannerAbouts from "../../components/main/SectioBannerAbouts";
import Sectionvalue from "../../components/main/SectionValue";
import SectionOrientation from "../../components/main/SectionOrientation";
import SEOHead from "../../components/common/SEOHead";
import JsonLd from "../../components/common/JsonLd";

const About: React.FC = () => {
  const faqs = [
    {
      key: "1",
      q: "Làm thế nào để liên hệ với TrioCore Solutions?",
      a: "Bạn có thể liên hệ qua hotline, email hoặc form liên hệ trên website. Đội ngũ TrioCore Solutions sẽ phản hồi nhanh để hỗ trợ tư vấn phù hợp.",
    },
    {
      key: "2",
      q: "Thời gian làm việc của TrioCore Solutions như thế nào?",
      a: "Chúng tôi làm việc từ Thứ 2 đến Thứ 6: 8:00 - 17:30 và Thứ 7: 8:00 - 12:00. Ngoài ra, TrioCore vẫn có thể tiếp nhận yêu cầu trực tuyến ngoài giờ khi cần thiết.",
    },
    {
      key: "3",
      q: "TrioCore Solutions có văn phòng ở đâu?",
      a: "Trụ sở: 64/9 Nguyễn Phúc Chu, Tân Sơn, HCM. Văn phòng: Lầu 1, 64/9 Nguyễn Phúc Chu, Tân Sơn, HCM.",
    },
    {
      key: "4",
      q: "Có hỗ trợ tư vấn miễn phí không?",
      a: "Có. TrioCore Solutions hỗ trợ tư vấn miễn phí để giúp doanh nghiệp xác định hướng đi phù hợp về công nghệ, website, phần mềm và marketing.",
    },
    {
      key: "5",
      q: "Làm sao để nhận báo giá nhanh nhất?",
      a: "Bạn chỉ cần để lại thông tin qua form hoặc liên hệ trực tiếp hotline. Chúng tôi sẽ tiếp nhận nhu cầu, rà soát phạm vi và phản hồi báo giá trong thời gian sớm nhất.",
    },
    {
      key: "6",
      q: "TrioCore Solutions ngoài làm website thì còn cung cấp dịch vụ nào khác không?",
      a: "Chúng tôi là một Tech & Digital Agency toàn diện. Bên cạnh thế mạnh thiết kế website, TrioCore chuyên sâu về xây dựng phần mềm quản trị (CRM, ERP tinh gọn), triển khai các chiến dịch Digital Marketing tối ưu số và bảo trì hệ thống công nghệ cho doanh nghiệp.",
    },
    {
      key: "7",
      q: "Tôi có thể kết hợp làm web và chạy Marketing tổng thể tại công ty không?",
      a: "Hoàn toàn được. Điểm mạnh của TrioCore là sự đồng bộ. Chúng tôi xây dựng nền tảng web chuẩn kỹ thuật, sau đó trực tiếp triển khai Marketing để đảm bảo dữ liệu đổ về mượt mà, tối ưu chi phí và tăng tỷ lệ chuyển đổi tốt nhất cho bạn.",
    },
  ];

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Trang chủ",
        "item": "https://triocoresolutions.com.vn/",
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Giới thiệu",
        "item": "https://triocoresolutions.com.vn/about",
      },
    ],
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <SEOHead
        title="Giới Thiệu — TrioCore Solutions"
        description="Tìm hiểu về TrioCore Solutions - đội ngũ chuyên nghiệp đồng hành cùng doanh nghiệp số hóa quy trình, thiết kế website và thúc đẩy tăng trưởng thông qua các giải pháp công nghệ tối ưu."
        path="/about"
      />
      <JsonLd data={breadcrumbSchema} />
      <SectionBannerAbouts />
      <Sectionvalue />
      <SectionOrientation />
      <SectionStrong />
      <SectionQuestion
        title="Câu hỏi thường gặp về TrioCore Solutions"
        faqs={faqs}
        img={
          <img
            className="absolute -top-2 left-2 w-[360px] object-cover lg:-top-4 lg:left-0 lg:w-[320px] xl:w-[350px]"
            src={PandaQuestion1}
            alt="Panda Mascot"
            width="360"
            height="360"
            loading="lazy"
          />
        }
      />
    </div>
  );
};

export default About;
